import React, { useEffect, useState } from 'react'
import { GetSuppliers } from '../../../Services/ProductService'
import { useConfig } from '../../../Providers/ConfigProvider'
import axios from 'axios'

const useGetSuppliers = () => {
    const { api } = useConfig()
    const [suppliers, setSuppliers] = useState([])

    const handleGetSuppliers = (productFilters, cancelToken) => {
        let tmpProductFilters = { ...productFilters, Suppliers: [] }
        GetSuppliers(api, tmpProductFilters, cancelToken).then(res => {
            setSuppliers(res.data)
        })
            .catch(e => {
                if (!axios.isCancel(e)) {
                    console.log(e)
                    setSuppliers([])
                }
            })
    }

    return { suppliers, handleGetSuppliers }
}

export default useGetSuppliers